interface HeroProps {
  query: string;
  onQueryChange: (v: string) => void;
  onSearch: () => void;
  onQuickSearch: (term: string) => void;
}

const quickTags = ['恋爱', '奇幻', '校园', '悬疑', '完结'];

const stats = [
  { value: '10,000+', label: '在线作品' },
  { value: '每周 40+', label: '新作首发' },
  { value: '7 大', label: '题材分类' },
  { value: '24h', label: '榜单实时' },
];

export default function Hero({ query, onQueryChange, onSearch, onQuickSearch }: HeroProps) {
  return (
    <section id="home" className="relative flex min-h-[560px] md:min-h-[640px] items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=colorful%20Korean%20webtoon%20storyboard%20mosaic%20background%2C%20warm%20coral%20orange%20cream%20and%20soft%20golden%20tones%2C%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20modern%20editorial%20illustration%2C%20warm%20and%20inviting%2C%20high%20detail&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="高清韩国漫画在线阅读平台首屏背景插画"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/60" />

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 md:px-8 py-16 md:py-24 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-sm font-medium backdrop-blur-sm">
          <i className="ri-fire-fill text-accent-400 w-4 h-4 flex items-center justify-center" />
          全网热门韩漫 · 每日更新 · 高清畅读
        </span>

        <h1 className="mt-6 font-heading text-3xl md:text-6xl text-background-50 leading-tight drop-shadow-sm">
          高清韩国漫画
          <span className="text-accent-300">一网打尽</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base md:text-lg text-background-100 leading-relaxed">
          恋爱、奇幻、校园、悬疑……题材分类齐全，完结作品随时可看。人气排行榜帮你快速锁定高分佳作，
          按口味选漫不踩雷，官网入口一站满足所有韩漫阅读需求。
        </p>

        <form
          className="mx-auto mt-8 flex max-w-xl flex-col sm:flex-row items-stretch gap-3"
          onSubmit={(e) => {
            e.preventDefault();
            onSearch();
          }}
          role="search"
          aria-label="站内搜索"
        >
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-background-400 w-5 h-5 flex items-center justify-center" />
            <input
              type="text"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索你想看的韩漫作品"
              className="w-full pl-12 pr-4 py-3.5 rounded-full bg-background-50 text-foreground-950 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
            />
          </div>
          <button
            type="submit"
            className="px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            立即搜漫
          </button>
        </form>

        <div className="mt-5 flex flex-wrap justify-center gap-2">
          {quickTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onQuickSearch(tag)}
              className="px-3.5 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs font-medium hover:bg-background-50/25 cursor-pointer whitespace-nowrap"
            >
              {tag}作品
            </button>
          ))}
        </div>

        <dl className="mx-auto mt-10 grid max-w-2xl grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-50/10 backdrop-blur-sm px-4 py-4">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-xl md:text-2xl text-accent-300">{s.value}</dd>
              <dd className="mt-1 text-xs text-background-200">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}